import React, { useState } from 'react';
import './CTA.css';
import { FaCalendarAlt } from 'react-icons/fa';
import DemoForm from './DemoForm';

const CTA = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDemoClick = (e) => {
    e.preventDefault();
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted');
    setShowForm(false);
    window.open('http://calendly.com/', '_blank');
  };

  return (
    <section className="cta">
      <div className="cta-container">
        <h2 className="cta-title">Start booking more patients today</h2>
        <div className="cta-buttons">
          <a href="http://calendly.com/" className="book-demo-btn" onClick={handleDemoClick}>
            <FaCalendarAlt />
            Book a free demo
          </a>
        </div>
      </div>
      {showForm && <DemoForm onClose={handleFormClose} onSubmit={handleFormSubmit} />}
    </section>
  );
};

export default CTA;
